<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap align-space-around fill-height>
      <v-flex d-flex>
      <v-card flat>
        <v-card-text>
          <v-window v-model="step">
            <v-window-item :value="1">
              <template v-if="waive">
                Are you sure you would like to waive the price adjustment fee of ${{ (transaction.fee_amount / 100).toFixed(2) }}<span v-if="transaction.billing_name"> for {{ transaction.billing_name }}</span>?
              </template>
              <template v-else>
                Are you sure you would like to void the transaction of ${{ (transaction.total_amount / 100).toFixed(2) }}<span v-if="transaction.billing_name"> for {{ transaction.billing_name }}</span>?
              </template>
            </v-window-item>

            <v-window-item :value="2">
              <template v-if="!waive || transaction.request_type === 'ach' || transaction.request_type === 'achvoid' || transaction.request_type === 'achcredit'">
                Transaction successfully voided.
              </template>
              <template v-else>
                Transaction successfully voided. Would you like to run another charge without the price adjustment fee?
              </template>
            </v-window-item>

            <v-window-item :value="3">
              <div v-if="passwordError">Incorrect password.</div>
              <div>Please enter the password to waive the price adjustment fee:</div>
              <v-text-field
                label="Password"
                v-model="password"
                append-icon="lock"
                box
                hide-details
                type="password"
              />
            </v-window-item>

            <v-window-item :value="4">
              There was an error voiding the transaction: {{ error }}
            </v-window-item>
          </v-window>
        </v-card-text>

        <v-spacer></v-spacer>

        <v-progress-linear :indeterminate="loading" height="1" />

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="runVoid" v-if="step === 1">Yes</v-btn>
          <v-btn color="primary" @click="checkPassword" v-if="step === 2 || step === 3">Yes</v-btn>
          <v-btn color="primary" @click="closeOptionsModal" v-if="step !== 4">No</v-btn>
        </v-card-actions>
      </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      enabled: false,
      step: 1,
      loading: false,
      error: '',
      password: '',
      passwordError: false
    }
  },

  props: {
    transaction: Object,
    waive: Boolean
  },

  mounted () {
    if (this.appReady) {
      this.init()
    } else {
      Bus.$on('appReady', this.init)
    }
  },

  methods: {
    async init () {},

    closeOptionsModal (id = '') {
      // this.transaction = {}
      this.step = 1
      this.error = ''
      this.loading = false
      this.password = ''
      this.passwordError = false

      if (id) {
        Bus.$emit('openTransaction', id)
      } else {
        Bus.$emit('closeOptionsModal')
      }
    },

    // @TODO exports.validateManagerPassword = async (user_id, account_id, token_id, password) => {
    async checkPassword () {
      try {
        if (this.waive && this.step !== 3 && this.transaction.account_manager_password && !this.hasPermission('can_waive_without_password') && this.transaction.request_type !== 'ach' && this.transaction.request_type !== 'achvoid' && this.transaction.request_type !== 'achcredit') {
          this.step = 3
        } else {
          if (this.waive && this.transaction.account_manager_password && (!this.hasPermission('can_waive_without_password') && this.transaction.account_manager_password !== this.password) && this.transaction.request_type !== 'ach' && this.transaction.request_type !== 'achvoid' && this.transaction.request_type !== 'achcredit') {
            this.passwordError = true
          } else {
            // Bus.$emit('chargeWaiveFee')
            // Bus.$emit('voidSuccessful')
            // this.closeOptionsModal()
            this.runCharge()
          }
        }
      } catch (err) {
        this.loading = false
        this.error = err
        this.step = 4
      }
    },

    runCharge () {
      let query = {
        transaction: this.transaction.id
      }

      if (this.waive) {
        this.$store.commit('waive', this.transaction.id)
        delete query.transaction
        query.rerun = this.transaction.id
      }

      if (this.transaction.request_type === 'ach' || this.transaction.request_type === 'achvoid' || this.transaction.request_type === 'achcredit') {
        this.$router.push({name: 'ChargeACH', query: query})
      } else {
        this.$router.push({name: 'ChargeCard', query: query})
      }
    },

    async runVoid () {
      try {
        if (!this.transaction) {
          throw new Error('Unable to identify transaction')
        }

        if (this.transaction.voided) {
          throw new Error('Transaction has already been voided')
        }

        if (this.transaction.refunded_transaction_id) {
          throw new Error('Transaction has already been refunded')
        }

        let message = 'Voiding is not reversable, are you absolutely sure you would like to void this transaction?'

        if (this.waive) {
          message = 'Waiving the price adjustment fee is not reversable, are you absolutely sure you would like to waive the price adjustment fee for this transaction?'
        }

        if (confirm(message)) {
          let options = {
            terminal_id: this.transaction.terminal_id,
            transaction_id: this.transaction.id
          }

          this.loading = true

          // if (this.transaction.is_recurring && this.transaction.recurring_type !== 'none') {
          //   let options = {
          //     account_id: this.transaction.account_id,
          //     terminal_id: this.transaction.terminal_id,
          //     token_id: this.transaction.token_id,
          //     transaction_id: this.transaction.custom_tracking_id,
          //     recurring_type: 'none',
          //     total_amount: this.transaction.total_amount // required for FAPS
          //   }

          //   Bus.$emit('openWaitModal')
          //   let result = await this.api({
          //     method: 'post',
          //     url: `/terminal/modify`,
          //     data: options
          //   })
          //   Bus.$emit('closeWaitModal')

          //   if (result.data) {
          //     if (result.data.response.ResponseText !== 'MODIFY ACCEPTED') {
          //       let error = result.data.response.ResponseText
          //       if (result.data.response.ErrMsg) {
          //         error += ': ' + result.data.response.ErrMsg
          //       }
          //       throw new Error(error)
          //     }
          //   } else {
          //     throw new Error('Unexpected Error')
          //   }
          // }

          Bus.$emit('openWaitModal')
          let result = await this.api({
            method: 'post',
            url: `/terminal/void`,
            data: options
          })
          Bus.$emit('closeWaitModal')

          if (result.data.response.ActionCode === '000') {
            // Bus.$emit('voidSuccessful')
            if (this.waive) {
              // this.step = 3
              this.checkPassword()
            } else {
              // this.step = 2
              Bus.$emit('openModal', {status: 'success', message: 'Void successful'})
              // this.closeOptionsModal(result.data.response.UniqueID)
              this.closeOptionsModal()
              // Bus.$emit('optionsClose')
            }
          } else {
            let error = result.data.response.ResponseText
            if (result.data.response.ErrMsg) {
              error += ': ' + result.data.response.ErrMsg
            }

            this.error = error
            this.step = 4
          }

          this.loading = false
        }
      } catch (err) {
        this.loading = false
        this.error = err
        this.step = 4
        Bus.$emit('closeWaitModal')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/Void.vue